import successTrx from 'assets/images/success-trx.png'
import { getMetaContent } from 'helpers'
import { Card, Container } from 'reactstrap'

const SuccessPage = ({ body }) => {
  return (
    <Container className="mt-2">
      <Card
        style={{ maxWidth: 480 }}
        className="px-2 mx-auto d-flex justify-content-center align-items-center"
      >
        <img
          src={getMetaContent('og:image')}
          alt={`${getMetaContent('og:title')} logo`}
          className="text-center"
          style={{
            marginTop: 32,
            marginBottom: 24,
            width: '100%',
            maxWidth: '150px',
            height: 'auto',
          }}
        />

        <img
          style={{ width: '280px', height: '182px' }}
          alt="success transaction"
          src={successTrx}
        />
        {body ? (
          body
        ) : (
          <>
            <h6 className="fw-bold mt-3">Konfirmasi diterima</h6>
            <span className="mb-4" data-testid="order-success-message">
              Transaksi anda telah selesai!
            </span>
          </>
        )}
      </Card>
    </Container>
  )
}

export default SuccessPage
